export default {
  svgPath: `
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.375 8.78l1.25-1.56L10 10.72l4.375-3.5 1.25 1.56L10 13.28l-5.625-4.5z"/>
  `,
  title: 'Chrevron Down',
  viewBox: '0 0 20 20',
};
